"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollElementIntoViewById = void 0;
const scrollElementIntoViewById = (elementId, options = {}) => {
    const scrollToElement = document.getElementById(elementId);
    if (scrollToElement instanceof HTMLElement) {
        scrollToElement.scrollIntoView(options);
    }
};
exports.scrollElementIntoViewById = scrollElementIntoViewById;
//# sourceMappingURL=dom.js.map